<template>
  <div class="edit-container">
    <div
      class="edit-container__body g-edit-component"
    >
      <div class="edit-container__steps-wrapper">
        <ol class="edit-container__steps">
          <li
            v-for="step in steps"
            :key="step.name"
            class="edit-container__steps__step"
            @click="selectedStep = step"
          >
            <button
              class="g-btn g-btn--rounded edit-container__steps__step__text"
              :class="{'edit-container__steps__step__text--active': selectedStep.name === step.name}"
            >
              {{ step.name }}
            </button>
          </li>
        </ol>
      </div>
      <div class="edit-container__header">
        <h2>{{ `${computedSensorData.data.sdname} - ${selectedStep.name}` }}</h2>
      </div>
      <component
        :is="selectedStep.component"
        v-if="selectedStep"
        :socket-message="SocketMessage"
        :sensor-data="ModalData.data.data"
        :sensors="ModalData.data.sensors"
        :blank-sensor="ModalData.data.blankSensor"
        :store="store"
        :page-message = "PageMessage"
        @SetPageMessage="SetPageMessage"
        @CloseModal="CloseModal"
      />
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle, MicroService} from '@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

/** Programs */
import EditProgramType from'@/components/EditProgramType'
import EditSensorDecoderParameters from'@/components/EditSensorDecoderParameters'
import EditSensorDecoderSettings from'@/components/EditSensorDecoderSettings'
import EditSensorDecoderAlarms from'@/components/EditSensorDecoderAlarms'

export default {
  name: 'EditSensors',
  components: {
    'edit-sensor-parameters': EditSensorDecoderParameters,
    'edit-sensor-settings': EditSensorDecoderSettings,
    'edit-sensor-alarms': EditSensorDecoderAlarms
  },
  mixins: [SocketHandler, LifeCycle, MicroService],
  props: {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      selectedStep: this.ModalData.data.steps[0],
      steps: []
    }
  },
  computed: {
    computedSensorData() {
      return this.ModalData.data.data
    }
  },
  watch: {
    computedSensorData: {
      handler(val) {
        console.log('recalculating steps')
        const keysforSettings = [ 
          'sdaddr',
          'sdtype',
          'kfact',
          'offset',
          'adjust',
          'units'
        ]
        const noSettings = !Object.keys(this.computedSensorData.status).some(key => keysforSettings.includes(key) && this.computedSensorData.status[key])

        this.steps = !noSettings
        ? this.ModalData.data.steps
        : this.ModalData.data.steps.filter(step => step.name !== 'Settings')
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
  },
  destroyed() {
    this.$emit('SetPageMessage', {
      target: 'sensors',
      command: 'updateInformation'
    })
  },
  methods: {
    CloseModal() {
      this.$emit('CloseModal')
    },
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    StepButtonClick(StepIndex) {
      this.Step = StepIndex
    }
  }
}
</script>

<style lang="scss">
  %button-modifier {
    border-radius: $application-base-border-radius;
    border-bottom-left-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin: 0 2px;
    height: 40px;
    transform: translate3d(-2px, 0, 0);
    box-shadow: 0 -3px 3px -2px $color-grey-dark inset;
    border: 0;
  }

  .edit-container {
    $max-width: $bp-desktop;
    position: relative;
    max-width: $max-width;
    overflow: hidden;

    hr {
      margin: 0;
      border: 0;
      border-top: 1px solid lighten($color-black, 90);
      background: transparent;
    }

    .g-btn {
      &--toggle {
        margin: 20px 5px
      }
    }

    .edit-sensor-parameters, .edit-sensor-setup, .edit-sensor-alarms {
      transition: all 1s;
      background: $color-white;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      grid-gap: 20px;
      padding: 10px 10px;

      &__title, label {
        display: block;
        margin: 5px;
        font-size: 14px;
        font-family: 'Montserrat-SemiBold';
        font-weight: normal;

        + .input-element {
          padding-top: 0;
        }
      }
    }

    &__header {
      background: $color-white;
      padding: 20px 0 15px;
      border-bottom: 1px solid $color-grey;

      h2 {
        margin: 0 0 0 15px;
        padding-bottom: 2px;
      }
    }

    &__body {
      width: 100vw;
      max-width: $max-width;
      padding-bottom: 100px;
      transition: all 1s;
      background: transparent !important;
    }

    &__error {
      box-sizing: border-box;
      background: $color-white;
      padding: 10px 20px;
      max-width: $max-width;
      min-width: 200px;
      width: 100%;
      border-radius: $application-base-border-radius !important;
      line-height: 18px;

      p {
        margin-bottom: 0;
      }

      &__action {
        text-align: center;
      }

      .g-btn {
        margin: 20px auto;
      }
    }

    &__continue {
      $size: 33px;
      border: 0;
      font-size: $size;
      padding: 0 2px 0 8px;
      margin: 0 !important; // @TODO: No !important
      font-size: 13px;
      display: flex;
      align-items: center;
      border-radius: $application-base-border-radius !important;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;

      > * {
        font-size: $size * 0.75;
        top: 0;
        left: 0;
        color: $color-button-blue;
        border: 2px solid $color-white;
        border-radius: 50%;
        margin-left: 5px;
      }
    }

    &__steps-wrapper {
      display: flex;
      align-items: stretch;

      > * {
        margin: 0;
      }
    }

    &__steps {
      width: 100%;
      &__step {
        width: 100%;
        button {
          text-align: left;
        }
        .g-btn {
          width: 100%;
          @extend %button-modifier;
        }
        &__text {
          color: lighten($color-grey-darker, 10);
          span {
            display: inline-block;
            $size: 18px;
            text-align: center;
            width: $size;
            height: $size;
            border: 1px solid $color-grey-darker;
            border-radius: 50%;
          }
          &--active {
            color: $color-button-blue;
            font-family: $font-primary-semibold;
          }

          &--completed {
            color: $color-grey-darker;
          }

          &--disabled {
            color: $color-grey !important; // @TODO: No !important
            cursor: default;
          }
        }
      }
    }

  }

  @media screen and (min-width: $bp-mobile) {
    .edit-container {
      &__body {
        width: 85vw !important;
      }
    }
  }

  @media screen and (min-width: $bp-tablet - 1) {
    .edit-container {
      &__header {
        border-top-right-radius: $application-base-border-radius;
      }
      &__steps {
        width: auto;
        &__step {
          display: inline-block;
          width: auto;
          button {
            text-align: center;
          }
          .g-btn {
            width: auto;
          }
          &__text {
            &--active {
              box-shadow: none !important;
            }
          }
        }
      }
    }
  }
</style>
